export default __webpack_public_path__ + "static/media/mob-group_us.5e940397.png";